import { WebPlugin } from '@capacitor/core';
export class ScreenRecorderWeb extends WebPlugin {
    async start() {
        throw new Error('Method not implemented.');
    }
    async stop() {
        throw new Error('Method not implemented.');
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map